import React, { Component } from "react";
import {
  TouchableOpacity,
  View,
  StyleSheet,
  Dimensions,
  //Switch,
  Platform,
  ScrollView,
  TouchableHighlight,
} from "react-native";
import Text from "./TextFont";
import { connect } from "react-redux";
import ArButton from "../argon-ui/Button";

import Theme from "../argon-ui/Theme";
import { IconButton } from "./Buttons";
import { translate } from "../locales/translate";
import Countdown from "../components/CountDown";
import * as AreaActions from "../actions/AreaActions";
import * as CONSTANTS from "../../assets/consts";

import * as DeviceTypes from "../components/devices/_deviceTypes";
import * as AreaHelper from "../actions/AreaHelper";
//import DeviceInfo from "react-native-device-info";

import FontAwesomeIcon from "./FontAwesomeIcon";
import * as faCharCodes from "../../assets/consts/faCharCodes";
import AreaArmItem from "./AreaArmItem";

import Select from "../nativeBase-ui/Select";
import ModalBase from "../nativeBase-ui/ModalBase";
import { HStack } from "native-base";
import { getDir, getIsRTL } from "../util";
const SCREEN_WIDTH = Dimensions.get("screen").width;
const IMAGE_SIZE = 48;

const IS_MOBILE = Platform.OS === "android" || Platform.OS === "ios";
const SIRENS_DURATION = [
  {
    label: "5 " + translate("app.minute"),
    value: 5,
  },
  {
    label: "10 " + translate("app.minute"),
    value: 10,
  },
  {
    label: "15 " + translate("app.minute"),
    value: 15,
  },
];
class Area extends Component {
  constructor(props) {
    super(props);
    let { expanded } = this.props;
    this.state = {
      fontsLoaded: false,
      showArmModal: false,
      armCountDownStarted: false,
      shouldTurnOffLights: true,
      shouldTurnOffAirConditioners: true,
      shouldCheckDoorWindowsClosed: true,
      shouldUnlockAfterDisArm: true,
      devicesToUnlockAfterDisArm: [],
      shouldRunScenarios: true,
      shouldCloseCurtains: true,
      shouldNotifyBreach: true,
      shouldSmsBreach: true,
      shouldTurnOnSirens: true,
      armInProgress: false,
      areaStateIcon: null,
      userState: null,
      // showShouldCloseCurtains: true,
      // === dropDown - Quick access list ===
      openDropDown: false,
      sirensDuration: 5,
    };
    // this.areaModel = undefined;
  }

  componentDidMount() {
    this.props.onSelectItemFirstLoad();
    // this.areaModel = AreaHelper.findAreaById(
    //   this.props.AreaReducer.areas,
    //   this.props.areaId
    // );
    this.getAreaStateIcon();

    //@TODO: should uncomment when all clients receive new native update
    // if (IS_MOBILE) {
    //   DeviceInfo.supportedAbis()
    //     .then((abis) => {
    //       if (abis.includes("armeabi-v7a")) {
    //         this.setState({ isCameraViewSupported: true });
    //       }
    //     })
    //     .catch(console.log);
    // }
  }

  renderArmModal = () => {
    if (this.props.armReport && this.props.armReport.error) {
      return (
        <View style={{ flex: 1, justifyContent: "center" }}>
          <Text style={{ color: "#F00", textAlign: "center" }}>
            {translate(`area.${this.props.armReport.error}`)}
          </Text>
        </View>
      );
    }
    if (
      (this.props.armReport && this.props.armReport.inProgress) ||
      !this.props.isArmed
    ) {
      var definedScenarios = [];
      if (this.state.showArmModal) {
        definedScenarios = this.props.ScenarioReducer.scenarios
          .filter(
            (s) =>
              s.conditions &&
              s.conditions.some(
                (c) =>
                  c.isMain &&
                  c.areaId == this.props.areaId &&
                  c.listenerName == "AreaArmListener" &&
                  c.eventName == "OnAreaArmed"
              )
          )
          .map((s) => s.name);
      }

      var sirens = this.getAreaSirens();

      return (
        <View style={{ flex: 1, justifyContent: "center" }}>
          {this.props.areaName != undefined && (
            <Text
              style={{
                textAlign: "center",
                fontSize: 18,
                marginBottom: 8,
                fontWeight: "bold",
                //marginBottom: 15,
              }}
            >
              {this.props.areaName}
            </Text>
          )}
          <ScrollView style={style.armOption}>
            {/* shouldCheckDoorWindowsClosed */}
            <AreaArmItem
              value={this.state.shouldCheckDoorWindowsClosed}
              label={translate("area.shouldCheckDoorWindowsClosed")}
              armInProgress={this.state.armInProgress}
              status={
                this.props.armReport &&
                this.props.armReport.shouldCheckDoorWindowsClosed
              }
              onChange={() =>
                this.setState(
                  {
                    shouldCheckDoorWindowsClosed:
                      !this.state.shouldCheckDoorWindowsClosed,
                  },
                  () => {
                    this.props.ResetArmReport(this.props.areaId);
                  }
                )
              }
              errorMessage={
                Array.isArray(this.props.armReport.openWindows) &&
                this.props.armReport.openWindows.length > 0
                  ? this.props.armReport.openWindows.length == 1
                    ? translate("area.openWindowError", {
                        openWindows:
                          this.props.armReport.openWindows.toString(),
                      })
                    : translate("area.openWindowsError", {
                        openWindows:
                          this.props.armReport.openWindows.toString(),
                      })
                  : null
              }
            />

            {/* shouldCloseCurtains */}
            {this.props.blinds > 0 && (
              <AreaArmItem
                value={this.state.shouldCloseCurtains}
                label={translate("area.shouldCloseCurtains")}
                armInProgress={this.state.armInProgress}
                status={
                  this.props.armReport &&
                  this.props.armReport.shouldCloseCurtains
                }
                onChange={() =>
                  this.setState({
                    shouldCloseCurtains: !this.state.shouldCloseCurtains,
                  })
                }
              />
            )}
            {/* shouldTurnOffLights */}
            {this.props.lights > 0 && (
              <AreaArmItem
                value={this.state.shouldTurnOffLights}
                label={translate("area.shouldTurnOffLights")}
                armInProgress={this.state.armInProgress}
                status={
                  this.props.armReport &&
                  this.props.armReport.shouldTurnOffLights
                }
                onChange={() =>
                  this.setState({
                    shouldTurnOffLights: !this.state.shouldTurnOffLights,
                  })
                }
              />
            )}
            {/* shouldTurnOffAirConditioners */}
            {this.props.hvacs > 0 && (
              <AreaArmItem
                value={this.state.shouldTurnOffAirConditioners}
                label={translate("area.shouldTurnOffAirConditioners")}
                armInProgress={this.state.armInProgress}
                status={
                  this.props.armReport &&
                  this.props.armReport.shouldTurnOffAirConditioners
                }
                onChange={() =>
                  this.setState({
                    shouldTurnOffAirConditioners:
                      !this.state.shouldTurnOffAirConditioners,
                  })
                }
              />
            )}

            {/* shouldRunScenarios */}
            {definedScenarios.length > 0 && (
              <AreaArmItem
                value={this.state.shouldRunScenarios}
                label={translate("area.shouldRunScenarios")}
                armInProgress={this.state.armInProgress}
                status={
                  this.props.armReport &&
                  this.props.armReport.shouldRunScenarios
                }
                onChange={() =>
                  this.setState({
                    shouldRunScenarios: !this.state.shouldRunScenarios,
                  })
                }
                message={
                  translate("area.definedScenarios") +
                  ": " +
                  definedScenarios.join(", ")
                }
              />
            )}

            <View
              style={{
                borderBottomColor: Theme.COLORS.MUTED,
                borderBottomWidth: 1,
                marginVertical: 7,
                width: "95%",
              }}
            ></View>
            <Text style={{ fontSize: 11, marginEnd: 5 }}>
              {translate("area.notifyOnBreach")}
            </Text>

            <View style={{ marginStart: 20 }}>
              {/* shouldSendNotification */}
              <AreaArmItem
                value={this.state.shouldNotifyBreach}
                label={translate("area.shouldNotifyBreach")}
                armInProgress={false}
                status={undefined}
                onChange={() =>
                  this.setState({
                    shouldNotifyBreach: !this.state.shouldNotifyBreach,
                  })
                }
              />

              {/* shouldSendSMS */}
              <AreaArmItem
                value={this.state.shouldSmsBreach}
                label={translate("area.shouldSmsBreach")}
                armInProgress={false}
                status={undefined}
                onChange={() =>
                  this.setState({
                    shouldSmsBreach: !this.state.shouldSmsBreach,
                  })
                }
              />
              {/* shouldTurnOnSirens */}
              {sirens.length > 0 && (
                <AreaArmItem
                  value={this.state.shouldTurnOnSirens}
                  label={translate("area.shouldTurnOnSirens")}
                  onActiveToggleStyle={Theme.COLORS.ERROR}
                  armInProgress={false}
                  status={undefined}
                  onChange={() =>
                    this.setState({
                      shouldTurnOnSirens: !this.state.shouldTurnOnSirens,
                    })
                  }
                />
              )}
              {/* === sirens duration === */}
              {sirens.length > 0 && this.state.shouldTurnOnSirens && (
                <View style={{ padding: 5 }}>
                  <Text style={{ fontSize: 12, marginVertical: 5 }}>
                    {translate("area.sirensDuration", {
                      sirensDuration: this.state.sirensDuration,
                    })}
                  </Text>
                  <Select
                    data={SIRENS_DURATION.map(({ label, value }) => {
                      return {
                        label,
                        value,
                      };
                    })}
                    value={this.state.sirensDuration || 5}
                    onChangeText={(value, index, data) => {
                      this.setState({ sirensDuration: Number(value) });
                    }}
                  />
                </View>
              )}
            </View>
          </ScrollView>
        </View>
      );
    } else {
      var areaLocks = this.getAreaLocks();
      return (
        <View style={{ flex: 1 }}>
          <View style={{ flex: 1, marginBottom: 20 }}>
            {this.props.areaName != undefined && (
              <Text
                style={{
                  textAlign: "center",
                  fontSize: 18,
                  marginTop: 8,
                  marginBottom: 15,
                  fontWeight: "bold",
                }}
              >
                {this.props.areaName}
              </Text>
            )}
            <Text style={{ textAlign: "center", fontSize: 12 }}>
              {translate("area.doYouConfirmDisarmArea")}
            </Text>
            {this.props.armReport && this.props.armReport.error && (
              <Text style={{ color: "#F00", textAlign: "center" }}>
                {translate(`area.${this.props.armReport.error}`)}
              </Text>
            )}
          </View>

          <View>
            {areaLocks.length > 0 && (
              <View style={style.armOption}>
                {/* unlockDoorAfterDisarm */}
                {areaLocks.length > 0 && (
                  <AreaArmItem
                    value={this.state.shouldUnlockAfterDisArm}
                    label={translate("area.shouldUnlockAfterDisArm")}
                    armInProgress={false}
                    status={
                      this.props.armReport &&
                      this.props.armReport.shouldCheckDoorWindowsClosed
                    }
                    onChange={() => {
                      if (this.state.devicesToUnlockAfterDisArm.length == 0) {
                        var devicesToUnlockAfterDisArm =
                          this.getAreaLocks().map((l) => l.deviceId);
                        this.setState({
                          shouldUnlockAfterDisArm:
                            !this.state.shouldUnlockAfterDisArm,
                          devicesToUnlockAfterDisArm,
                        });
                      } else {
                        this.setState({
                          shouldUnlockAfterDisArm:
                            !this.state.shouldUnlockAfterDisArm,
                        });
                      }
                    }}
                  />
                )}
                {this.state.shouldUnlockAfterDisArm && areaLocks.length > 1 && (
                  <View style={{ margin: 10 }}>
                    {areaLocks.map((l, i) => (
                      <AreaArmItem
                        key={i}
                        value={
                          this.state.devicesToUnlockAfterDisArm.indexOf(
                            l.deviceId
                          ) >= 0
                        }
                        label={l.deviceName}
                        armInProgress={false}
                        status={true}
                        onChange={() => {
                          let devicesToUnlockAfterDisArm = [
                            ...this.state.devicesToUnlockAfterDisArm,
                          ];
                          let { shouldUnlockAfterDisArm } = this.state;

                          if (
                            devicesToUnlockAfterDisArm.indexOf(l.deviceId) >= 0
                          ) {
                            devicesToUnlockAfterDisArm.splice(
                              devicesToUnlockAfterDisArm.indexOf(l.deviceId),
                              1
                            );
                            if (devicesToUnlockAfterDisArm.length == 0) {
                              shouldUnlockAfterDisArm = false;
                            }
                          } else {
                            devicesToUnlockAfterDisArm.push(l.deviceId);
                          }
                          this.setState({
                            devicesToUnlockAfterDisArm,
                            shouldUnlockAfterDisArm,
                          });
                        }}
                      />
                    ))}
                  </View>
                )}
              </View>
            )}
          </View>
        </View>
      );
    }
  };

  hideArmModal = () => {
    this.setState({
      showArmModal: false,
      armInProgress: false,
    });
    this.props.ResetArmReport(this.props.areaId);

    if (this.props.armReport && this.props.armReport.inProgress) {
    }
  };
  loadArmModal = () => {
    var devicesToUnlockAfterDisArm = this.getAreaLocks().map((d) => d.deviceId);
    this.setState({
      showArmModal: true,
      armCountDownStarted: false,
      devicesToUnlockAfterDisArm,
    });
  };

  getDevicesByType(deviceType = "") {
    var selectedDevices = [];
    var areaDevices = AreaHelper.findAreaById(
      this.props.AreaReducer.areas,
      this.props.areaId
    ).devices;
    for (var i in this.props.DeviceReducer.list) {
      var d = this.props.DeviceReducer.list[i];
      if (areaDevices.indexOf(d.deviceId) >= 0 && d.deviceType == deviceType) {
        selectedDevices.push(d);
      }
    }

    return selectedDevices;
  }

  getAreaLocks = () => {
    if (this.props.locks >= 1) {
      return this.getDevicesByType(DeviceTypes.DOORLOCK);
    }
    return [];
  };

  getAreaSirens = () => {
    if (this.props.sirens > 0) {
      return this.getDevicesByType(DeviceTypes.SIREN);
    }
    return [];
  };
  getAreaStateIcon = () => {
    if (this.props.userDefinedStates.length > 0) {
      for (var i in this.props.userDefinedStates) {
        if (this.props.userDefinedStates[i].isActivated) {
          return this.props.userDefinedStates[i];
        }
      }
    }
    return null;
  };
  handleOnItemCounterPress = (deviceType = DeviceTypes.LIGHT) => {
    deviceType &&
      this.props.areaId &&
      this.props.onAreaItemPress &&
      this.props.onAreaItemPress(
        this.props.areaId,
        this.props.areaUId,
        deviceType
      );
  };

  handleOnDoorLockPress = () => {
    this.handleOnItemCounterPress(DeviceTypes.DOORLOCK);
  };
  render() {
    // === set background color ===
    var _backgroundStyle = {};
    if (this.props.isBreached) {
      _backgroundStyle = style.wrapperBreachedExpanded;
    } else if (this.props.isArmed) {
      _backgroundStyle = style.wrapperArmedExpanded;
    }
    // === Safe Mode Button ===
    let Armed = null;
    if (this.props.isArmable) {
      let _armedColor1 = Theme.COLORS.INPUT,
        _armedColor2 = "#ccc",
        _armedIconSize = 20;
      if (this.props.isBreached) {
        (_armedColor1 = Theme.COLORS.WHITE),
          (_armedColor2 = Theme.COLORS.ERROR),
          (_armedIconSize = 22);
      } else if (this.props.isArmed) {
        (_armedColor1 = Theme.COLORS.WHITE),
          (_armedColor2 = "#ff9900"),
          (_armedIconSize = 22);
      }
      Armed = (
        <IconButton
          onPress={this.loadArmModal}
          style={{
            // padding: 3,
            backgroundColor: this.props.isBreached
              ? Theme.COLORS.ERROR
              : !this.props.isArmed
              ? Theme.COLORS.GRAY_LIGHT
              : "transparent",
            width: 35,
            height: 35,
            justifyContent: "center",
            alignItems: "center",
            // padding: 9,
            borderRadius: 5,
          }}
          icon={{
            code: this.props.isBreached
              ? faCharCodes.faExclamationTriangle
              : this.props.isArmed
              ? faCharCodes.faShieldCheck
              : faCharCodes.faShield,
            style: {
              color: _armedColor1,
              fontFamily: faCharCodes.FONT_FAMILIES.PRO_REGULAR,
              fontSize: _armedIconSize,

              transform: [{ rotate: "0deg" }],
            },
          }}
        />
      );
    }

    let AreaState = null;
    let userState = this.getAreaStateIcon();
    let areaStateIcon = userState?.activeIcon;
    let areaStateText = userState?.name || null;
    if (this.getAreaStateIcon() != null) {
      let _areaStateColor1 = "#ff8400",
        _areaStateIconSize = 20;
      AreaState = (
        <IconButton
          onPress={() => {
            typeof this.props.OnPressAreaStateIcon === "function" &&
              this.props.OnPressAreaStateIcon(userState);
          }}
          style={{
            padding: 3,
          }}
          icon={{
            code: areaStateIcon,
            style: {
              color: _areaStateColor1,
              fontFamily: faCharCodes.FONT_FAMILIES.PRO_REGULAR,
              fontSize: _areaStateIconSize,
              transform: [{ rotate: "0deg" }],
              marginLeft: 5,
            },
          }}
        />
      );
    }

    // === selected item ===
    const activeItem = this.props.areaId === this.props.selectedId;
    return (
      <View>
        <View
          style={[
            style.wrapper,
            { direction: getDir() },
            {
              ...this.props.style,
            },
            this.props.armReport &&
              Number(this.props.armReport.countDown) > 0 && {
                borderColor: Theme.COLORS.ORANGE,
                borderWidth: 1,
              },
          ]}
        >
          <View
            style={[
              activeItem
                ? style.itemActive
                : this.props.isArmed && _backgroundStyle,
              {
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
                // marginBottom: 5,
                height: 50,
                paddingHorizontal: 5,
                //   width: "100%",
              },
            ]}
          >
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                width: "55%",
              }}
            >
              {/* {(this.props.lights > 0 && !this.props.isArmed) ||
              (this.props.locks && !this.props.isArmed) ||
              (Platform.OS !== "web" &&
                this.props.isArmed &&
                this.props.cameras > 0) ? (
                <TouchableHighlight
                  underlayColor="transparent"
                  style={{
                    width: 20,
                    // marginHorizontal: 5,
                    height: 50,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  onPress={() => {
                    this.setState({ openDropDown: !this.state.openDropDown });
                  }}
                >
                  <FontAwesomeIcon
                    icon={faCharCodes.faEllipsisV}
                    size={15}
                    color={Theme.COLORS.BORDER}
                    style={
                      {
                        // borderColor: ArTheme.COLORS.BORDER_COLOR,
                        // borderEndWidth: 2,
                        // paddingHorizontal: 10,
                      }
                    }
                  ></FontAwesomeIcon>
                </TouchableHighlight>
              ) : (
                <View style={{ width: 20, marginHorizontal: 5 }} />
              )} */}
              {/* Area Name */}
              <TouchableOpacity
                onPress={() => this.props.onSelectItemAreaList()}
                style={[style.item, { paddingLeft: 0 }]}
              >
                <View>
                  <Text
                    numberOfLines={1}
                    style={[
                      style.title,
                      {
                        color: activeItem
                          ? Theme.COLORS.WHITE
                          : Theme.COLORS.BLACK,
                        textAlign: getIsRTL() ? "right" : "left",
                      },
                    ]}
                  >
                    {this.props.areaName}
                  </Text>
                  {/* area state name  */}
                  {this.props.isArmed || this.props.isBreached ? (
                    <Text
                      style={{
                        fontSize: 8,
                        marginTop: 5,
                        color: activeItem
                          ? Theme.COLORS.WHITE
                          : this.props.isBreached
                          ? Theme.COLORS.ERROR
                          : Theme.COLORS.ORANGE,
                      }}
                    >
                      (
                      {this.props.isBreached
                        ? translate("area.isBreached")
                        : this.props.isArmed && translate("area.isArm")}
                      )
                    </Text>
                  ) : (
                    areaStateText != null && (
                      <Text
                        style={{
                          marginTop: 3,
                          color: Theme.COLORS.PLACEHOLDER,
                          fontSize: 10,
                          textAlign: "right",
                        }}
                      >
                        {translate("app.status")}
                        {":"} {areaStateText}
                      </Text>
                    )
                  )}
                </View>
              </TouchableOpacity>
            </View>
            {/* === Safe Mode === */}
            <View
              style={[
                {
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: 5,
                  backgroundColor: this.props.isArmed
                    ? Theme.COLORS.ORANGE
                    : "transparent",
                },
                // this.props.isArmed && style.safeModeShadow,
              ]}
            >
              {/* === userDefinedStates === */}
              <View>
                {/* === area state List */}
                {this.props.showAreaState && (
                  <TouchableHighlight
                    underlayColor="transparent"
                    style={{ marginHorizontal: 10 }}
                    onPress={() => {
                      this.props.onShowAreaStateRBSheet &&
                        this.props.onShowAreaStateRBSheet();
                    }}
                  >
                    <FontAwesomeIcon
                      icon={faCharCodes.faAngleDown}
                      size={16}
                      color={Theme.COLORS.BORDER}
                      style={{
                        borderColor: Theme.COLORS.BORDER_COLOR,
                        borderLeftWidth:
                          this.props.isArmable && getIsRTL() ? 2 : 0,
                        borderRightWidth:
                          this.props.isArmable && !getIsRTL() ? 2 : 0,
                        paddingHorizontal: 10,
                      }}
                    ></FontAwesomeIcon>
                  </TouchableHighlight>
                )}
              </View>
              {/* === Safe Mode Button === */}

              {this.props.isArmed != null && this.props.isArmed
                ? Armed
                : AreaState || Armed}
            </View>
          </View>
          {this.props.armReport &&
            Number(this.props.armReport.countDown) > 0 && (
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginHorizontal: 15,
                  top: -10,
                  direction: getDir(),
                }}
              >
                <Text style={{ fontSize: 9 }}>
                  {translate("area.willArmAfterCountDown")}
                </Text>
                <Countdown
                  until={this.props.armReport.countDown}
                  size={20}
                  digitStyle={{
                    backgroundColor: "#FFFFFF00",
                    paddingTop: 15,
                  }}
                  timeLabelStyle={{ color: "grey" }}
                  timeToShow={["S"]}
                  timeLabels={{
                    s: translate("timer.seconds"),
                  }}
                  onChange={(e) => {
                    if (e > 0 && !this.state.armCountDownStarted) {
                      this.setState({ armCountDownStarted: true });
                    } else if (this.state.showArmModal) {
                      setTimeout(() => {
                        this.setState({ showArmModal: false });
                      }, 100);
                    }
                  }}
                  onFinish={() => {
                    setTimeout(this.hideArmModal, 500);
                  }}
                  showSeparator={false}
                />
              </View>
            )}
        </View>
        {/* === DropDown Light & camera & doorLock  === */}
        {/* {(this.props.lights > 0 && !this.props.isArmed) ||
        (this.props.locks && !this.props.isArmed) ||
        (Platform.OS !== "web" &&
          this.props.isArmed &&
          this.props.cameras > 0) ? (
          <DropdownKiosk openDropDown={this.state.openDropDown}>
            {!this.props.isArmed && this.props.locks > 0 && (
              <IconButton
                onPress={this.handleOnDoorLockPress}
                icon={{
                  code: faCharCodes.faKey,
                  style: {
                    fontFamily: "FontAwesomeProLight",
                    fontSize: 18,
                    color: "#5444a6",
                  },
                }}
                style={[
                  style.titleDevice,
                  {
                    // borderColor: "#f3f3ff",
                    backgroundColor: "#f3f3ff",
                    // backgroundColor: "#666699",
                    shadowColor: "#f3f3ff",
                  },
                ]}
              />
            )}
            {!this.props.isArmed && this.props.lights > 0 && (
              <IconButton
                onPress={() => this.handleOnItemCounterPress(DeviceTypes.LIGHT)}
                icon={{
                  code: faCharCodes.faLightbulb,
                  style: {
                    fontFamily: "FontAwesomeProLight",
                    fontSize: 18,
                    color: "#ffcc00",
                  },
                }}
                style={[
                  style.titleDevice,
                  {
                    backgroundColor: "#fef5e1",
                    shadowColor: "#fef5e1",
                    // borderColor: "#ffcc00",
                    // backgroundColor: "#fffbeb",
                  },
                ]}
              />
            )}
            {this.props.isArmed && this.props.cameras > 0 && IS_MOBILE && (
              <IconButton
                onPress={() =>
                  this.handleOnItemCounterPress(DeviceTypes.CAMERA)
                }
                icon={{
                  code: faCharCodes.faCctv,
                  style: {
                    fontFamily: "FontAwesomeProLight",
                    fontSize: 18,
                    color: "#cc9966",
                  },
                }}
                style={[
                  style.titleDevice,
                  {
                    backgroundColor: "#feefe9",
                    shadowColor: "#feefe9",
                  },
                ]}
              />
            )}
          </DropdownKiosk>
        ) : null} */}
        {/* Arm modal */}
        {this.state.showArmModal && (
          <ModalBase
            header={
              (this.props.armReport && this.props.armReport.inProgress) ||
              !this.props.isArmed
                ? translate("area.activatingArm")
                : null
            }
            isOpen={this.state.showArmModal}
            onClose={() => this.hideArmModal()}
          >
            <ScrollView
              contentContainerStyle={{ padding: 5, flex: 1 }}
              // style={style.modalInsideWrapper}
            >
              {this.renderArmModal()}
              {/* submit button */}
              <HStack alignItems="center" space="2">
                <ArButton
                  isLoading={
                    (this.props.armReport && this.props.armReport.inProgress) ||
                    (!this.props.isArmed && this.state.armInProgress)
                  }
                  onPress={() => {
                    if (
                      (this.props.armReport &&
                        this.props.armReport.inProgress) ||
                      !this.props.isArmed
                    ) {
                      let {
                        shouldTurnOffLights,
                        shouldTurnOffAirConditioners,
                        shouldCheckDoorWindowsClosed,
                        shouldCloseCurtains,
                        shouldRunScenarios,
                        shouldNotifyBreach,
                        shouldTurnOnSirens,
                        shouldSmsBreach,
                        sirensDuration,
                      } = this.state;
                      let { areaId, areaUId } = this.props;
                      this.setState({ armInProgress: true });
                      let { currentServer } = this.props.AppReducer;
                      const accessToken = currentServer.accessToken;
                      this.props.Arm(
                        areaId,
                        areaUId,
                        accessToken,
                        shouldTurnOffLights,
                        shouldTurnOffAirConditioners,
                        shouldCheckDoorWindowsClosed,
                        shouldCloseCurtains,
                        shouldNotifyBreach,
                        shouldSmsBreach,
                        shouldRunScenarios,
                        shouldTurnOnSirens,
                        sirensDuration
                      );
                    } else {
                      let { currentServer } = this.props.AppReducer;
                      const accessToken = currentServer.accessToken;
                      this.props.Disarm(
                        this.props.areaId,
                        this.props.areaUId,
                        accessToken,
                        this.state.shouldUnlockAfterDisArm,
                        this.state.devicesToUnlockAfterDisArm
                      );
                      setTimeout(() => {
                        if (!this.props.armReport.error) {
                          this.hideArmModal();
                        }
                      }, 1500);
                    }
                  }}
                  style={{
                    ...style.modalBtn,
                  }}
                >
                  {translate("app.confirm")}
                </ArButton>
                {!this.state.armInProgress && (
                  <ArButton
                    color="muted"
                    variant="outline"
                    onPress={() => {
                      this.hideArmModal();
                    }}
                    style={[
                      {
                        ...style.modalBtn,
                      },
                      { marginBottom: 0 },
                    ]}
                  >
                    {translate("app.close")}
                  </ArButton>
                )}
              </HStack>
            </ScrollView>
          </ModalBase>
        )}
      </View>
    );
  }
}

const style = StyleSheet.create({
  item: {
    borderRadius: 5,
    padding: 5,
    paddingVertical: 10,
    width: "95%",
  },
  itemActive: {
    backgroundColor: Theme.COLORS.ACTIVE,
    borderRadius: 5,

    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.23,
    shadowRadius: 2.62,
    elevation: 4,
  },
  safeModeShadow: {
    shadowColor: Theme.COLORS.ORANGE,
    shadowOffset: {
      width: 0,
      height: 6,
    },
    shadowOpacity: 0.3,
    shadowRadius: 6.65,
    elevation: 9,
  },
  title: {
    fontSize: 12,
    marginHorizontal: 3,
  },
  modalBtn: {
    flex: 1,
    height: 40,
    marginBottom: 0,
    alignSelf: "center",
  },
  modalInsideWrapper: {
    backgroundColor: "#FFF",
    borderRadius: 15,
    flex: 1,
    margin: 20,
    // marginBottom: 0,
    // borderBottomLeftRadius: 0,
    // borderBottomRightRadius: 0,
    paddingTop: 15,
    borderColor: Theme.COLORS.BORDER,
    borderWidth: 1,
    width: Math.min(SCREEN_WIDTH, CONSTANTS.WEB_MAX_WIDTH) * 0.8,
    alignSelf: "center",
    //height: "70%",
    paddingHorizontal: 10,
  },
  areaImage: {
    width: IMAGE_SIZE,
    height: IMAGE_SIZE,
    borderRadius: IMAGE_SIZE / 2,
    marginHorizontal: 5,
    resizeMode: "cover",
    borderColor: "#FFF",
    borderWidth: 3,
  },
  titleSensor: {
    paddingEnd: 7,
    borderLeftWidth: 1,
    borderColor: "#ccc",
  },
  titleDevice: {
    marginHorizontal: 5,
    // borderWidth: 1,
    width: 40,
    height: 40,
    borderRadius: 8,
    justifyContent: "center",
    shadowOffset: {
      width: 0,
      height: 6,
    },
    shadowOpacity: 0.3,
    shadowRadius: 6.65,
    elevation: 9,
  },
  armOption: {
    flex: 1,
    padding: 5,
    paddingStart: 5,
    backgroundColor: "#f2f2f2",
    borderColor: Theme.COLORS.BORDER_COLOR,
    borderWidth: 1,
    borderRadius: 5,
    marginBottom: 10,
  },
  areaItem: {
    width: (SCREEN_WIDTH - 60) / 2,
    marginBottom: 15,
  },
  wrapper: {
    marginBottom: 8,
    borderRadius: 5,
    backgroundColor: "#fefefe",
    minHeight: 50,
  },
  wrapperExpanded: {
    backgroundColor: "#FFF", // EAEAEA
  },
  wrapperArmed: {
    backgroundColor: "#f3ece4",
  },
  wrapperBreached: {
    backgroundColor: Theme.COLORS.ERROR + "15",
  },
  wrapperArmedExpanded: {
    backgroundColor: "#f3ece4",
    borderRadius: 5,
  },
  wrapperBreachedExpanded: {
    backgroundColor: Theme.COLORS.ERROR + "15",
    borderRadius: 5,
  },

  areaItemActionWrapper: {
    width: 35,
    alignItems: "center",
    justifyContent: "flex-start",
  },
  areaTitle: {
    // flex: 1,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    // height: 50,
    paddingStart: 7,
    marginVertical: IS_MOBILE ? 5 : 15,
  },
  mediaPlayerContainer: {
    margin: 5,
    marginBottom: 15,
    paddingHorizontal: 10,
    borderRadius: 3,
  },
});

const mapStateToProps = (state) => {
  return {
    DeviceReducer: state.DeviceReducer,
    AreaReducer: state.AreaReducer,
    ScenarioReducer: state.ScenarioReducer,
    AppReducer: state.AppReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    Arm: (
      areaId,
      areaUId,
      accessToken,
      shouldTurnOffLights,
      shouldTurnOffAirConditioners,
      shouldCheckDoorWindowsClosed,
      shouldCloseCurtains,
      shouldNotifyBreach,
      shouldSmsBreach,
      shouldRunScenarios,
      shouldTurnOnSirens,
      sirensDuration
    ) =>
      dispatch(
        AreaActions.arm(
          areaId,
          areaUId,
          accessToken,
          shouldTurnOffLights,
          shouldTurnOffAirConditioners,
          shouldCheckDoorWindowsClosed,
          shouldCloseCurtains,
          shouldNotifyBreach,
          shouldSmsBreach,
          shouldRunScenarios,
          shouldTurnOnSirens,
          sirensDuration
        )
      ),
    Disarm: (
      areaId,
      areaUId,
      accessToken,
      shouldUnlockAfterDisArm,
      devicesToUnlockAfterDisArm
    ) =>
      dispatch(
        AreaActions.disarm(
          areaId,
          areaUId,
          accessToken,
          shouldUnlockAfterDisArm,
          devicesToUnlockAfterDisArm
        )
      ),
    ResetArmReport: (areaId) =>
      dispatch(AreaActions.resetLocalArmReport(areaId)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true,
})(Area);
